<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_RuleSettings')"
    width="620px"
    :close-on-click-modal="false"
    class="details-view"
    style="overflow: auto;margin-top: 100px;"
  >
    <div class="main-content" style="height: 300px;overflow: auto;">
      <el-form label-width="130px" style="width: 502px;margin-top: 10px;">
        <el-form-item :label="$t('CargoMsg.Cargo_ApplicationScope')">
          <div style="width: 100%;display: flex; align-items: center;">
            <el-checkbox v-model="form.useHqSet" :disabled="readonly" style="padding-left: 2px;">
              <span>{{ $t('CargoMsg.Cargo_GeneralSettings') }}</span>
            </el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <div style="margin-top: 10px;">
        <div style="display: flex;">
          <el-form label-width="130px" style="width: 502px;" :disabled="form.useHqSet && branchId !== 1">
            <el-form-item :label="$t('CargoMsg.Cargo_PreApproval')">
              <el-radio-group v-model="form.preApproval">
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_OperationReview') }}</el-radio>
                <el-radio v-if="showDeptReview" :label="2">{{ $t('CargoMsg.Cargo_DepartmentReview') }}</el-radio>
                <el-radio :label="3">{{ $t('CargoMsg.Cargo_FinanceApproval') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.ServiceScenarioApplication')">
              <!--  选择特定业务规则弹窗  -->
              <specific-business-rule-dialog
                input-width="100%"
                :lob="lob"
                :apply-ui-custom="true"
                :specific-business-rule-uuid="form.specificBusinessRuleUuid"
                :specific-business-rules="specificBusinessRules"
                style="width: 350px"
                @change="p => specificBusinessRuleChange(p)"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SceneParameters')">
              <el-input v-model="form.ruleParam" type="textarea" :rows="5" style="width: 350px;" />
            </el-form-item>
            <el-form-item>
              <i class="el-icon-warning" style="color: #e6a23c;font-size: 13px;" />
              {{ $t('CargoMsg.Cargo_RuleBasedApproval') }}
            </el-form-item>
            <!--            <el-form-item>-->
            <!--              <el-checkbox v-model="form.supervisorReview">{{ $t('CargoMsg.Cargo_NonRuleBypass') }}</el-checkbox>-->
            <!--            </el-form-item>-->
          </el-form>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import {
  getBillPaymentRuleSetting,
  getBranchBillPaymentSetting,
  saveBillPaymentRuleSetting
} from '@/api/sysManage/uiCustom'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import SpecificBusinessRuleDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/specificBusinessRuleDialog.vue'
import UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'

export default {
  name: 'BillPaymentRuleSettingDialog',
  components: { SpecificBusinessRuleDialog },
  props: {
    visible: { type: Boolean, required: true },
    pageType: { type: Number, required: true },
    branchId: { type: Number, required: true },
    lob: { type: String, required: true },
    specificBusinessRules: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      showDeptReview: false, // 是否显示部门审核
      TYPE_NAMES,
      form: {}
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.form.useHqSet = true // 默认总部设置
          this.form.preApproval = 3 // 前置审核默认财务审批
          const res = await getBranchBillPaymentSetting({
            pageType: UICustomConstants.BILLPAYMENT_NATIVE_MODULE,
            branchId: this.branchId
          })
          if (res.data) {
            this.showDeptReview = res.data.departmentApproval
          }
          this.form = await getBillPaymentRuleSetting({ pageType: this.pageType, branchId: this.branchId, useHqSet: this.form.useHqSet }).then(res => res.data)
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.form = {}
      }
    }
  },
  methods: {
    okHandler() {
      if (this.readonly) {
        this.innerVisible = false
        return
      }
      if (!this.form.preApproval) {
        this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PreApproval'))
        return
      }
      this.form.branchId = this.branchId
      const loading = getLoading4Cxt(this)
      saveBillPaymentRuleSetting(this.form).then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    // 选择特定业务规则
    specificBusinessRuleChange(data) {
      if (data) {
        this.form.specificBusinessRuleUuid = data.uuid
      } else {
        this.form.specificBusinessRuleUuid = ''
      }
    }
  }
}
</script>
